// import React from 'react';
import { FetchAPI, Mutex } from './auth-service';
// import icons from '../data/json/icons.json';

// for latest list of icons:
// https://github.com/google/material-design-icons/blob/master/font/MaterialIcons-Regular.codepoints

/* eslint no-useless-escape: off */

// font awesome icons to material
const iconTranslator = {
    'fas fa-exclamation-triangle': 'warning',
    'fal fa-lightbulb-exclamation': 'highlight',
    'fas fa-exclamation-circle': 'error',
    'fas fa-radiation-alt': 'apps',
    'fas fa-do-not-enter': 'remove_circle',
    'fas fa-bomb': 'alarm',
    'far fa-spider-black-widow': 'wb_incandescent',
    'fas fa-bug': 'bug_report',
    'fa fa-bug': 'bug_report',

    'fas fa-user-secret': 'enhanced_encryption',
    'fas fa-eye': 'visibility',
    'fas fa-unlock': 'lock_open',
    'fas fa-lock': 'lock',
    'fas fa-key': 'vpn_key',
    'fas fa-key-skeleton': 'security',
    'fas fa-check-circle': 'verified_user',
    'fas fa-times-circle': 'highlight_off',

    'fa fa-circle': 'fiber_manual_record',
    'fa fa-basketball-ball': 'title',
    'fa fa-bowling-ball': 'gamepad',
    'fa fa-futbol': 'laptop',
    'fa fa-golf-ball': 'computer',
    'fa fa-football-ball': 'device_hub',
    'fa fa-chess': 'videogame_asset',
    'fa fa-chess-rook': 'games',

    'fa fa-chess-queen': 'ac_unit',
    'fa fa-chess-pawn': 'accessibility',
    'fa fa-chess-knight': 'android',
    'fa fa-chess-bishop': 'airport_shuttle',
    'fa fa-bicycle': 'network_wifi',
    'fa fa-bullseye': 'bluetooth',
    'fab fa-pied-piper': 'attachment',
    'fab fa-pied-piper-pp': 'blur_on',

    'fa fa-thumbs-up': 'thumb_up',
    'fa fa-thumbs-down': 'thumb_down',
    'fa fa-gamepad': 'cake',
    'fa fa-beer': 'http',
    'fa fa-glass-martini': 'https',
    'fa fa-coffee': 'wifi_tethering',
    'fa fa-birthday-cake': 'router',
    'fa fa-lemon': 'dns',
};

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

class TagsDataService {
    constructor () {
        if (!TagsDataService.instance) {
            TagsDataService.instance = this;
            this.tagsMux = new Mutex();
        }

        return TagsDataService.instance;
    }

    // only want to call this guy one at a time
    async list (refresh, cmc) {
        const unlock = await this.tagsMux.lock();

        if (!refresh && this.tags) {
            unlock();
            return Promise.resolve(this.tags);
        }
        const prefix = MC2CHECK ? 'mc2/' : '';

        return FetchAPI({ method: 'GET', url: `${prefix}tags/` })
            .then(res => {
                this.tags = (res || []).reduce((a, c) => {
                    a[c.name] = c;
                    if (c.data) {
                        // pick a random icon if no icon found
                        // const iconArray = Object.keys(icons);
                        a[c.name].icon = iconTranslator[c.data.icon] || c.data.icon;
                        // ? icon
                        // : iconArray[Math.floor(Math.random() * iconArray.length)];
                        a[c.name].color = c.data.color;
                        a[c.name].name = c.name;
                    }
                    return a;
                }, {});
                return this.tags;
            }).catch(err => {
                console.log('cannot fetch tags', err);
            }).finally(() => unlock());
    }

    upsert (tag, cmc) {
        if (!tag || !tag.name) return Promise.reject(new Error('invalid tag', tag));

        cmc = tag.cmc || cmc;
        if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
        const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

        return FetchAPI({
            method: 'PUT',
            url: `${prefix}tags/${encodeURIComponent(tag.name)}/`,
            body: tag
        }).then(() => this.list(true, cmc));
    }

    delete (tag, cmc) {
        if (!tag || !tag.name) return Promise.reject(new Error('cannot delete tag', name));

        cmc = tag.cmc || cmc;
        if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
        const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

        return FetchAPI({
            method: 'DELETE',
            url: `${prefix}tags/${encodeURIComponent(tag.name)}/`
        }).then(() => this.list(true, cmc));
    }

    valid (name) {
        if (!name || !name.length) return false;
        if (this.tags[name]) return false;
        const keys = Object.keys(this.tags).map(t => t.toLowerCase());
        if (keys.includes(name.toLowerCase())) return false;

        return name.length <= 45 && /^\w[a-zA-Z0-9_\-. (){}\[\]]{0,44}$/.test(name);
    }
}

const TagsService = new TagsDataService();

export {
    TagsService as default,
};
